export default defineNuxtPlugin(() => {
  const nuxtApp = useNuxtApp()
  const { library } = $store()
  /** Vite glob import */
  const wards = import.meta.glob('assets/location/xa-phuong/**/**.json', {
    as: 'json',
    eager: false
  })
  const districts = import.meta.glob('assets/location/quan-huyen/**/**.json', {
    as: 'json',
    eager: false
  })
  return {
    provide: {
      location: {
        findDistrict: async (s: string = '', cityCode: string | undefined) => {
          if (!cityCode || cityCode === undefined || cityCode === '') {
            return []
          }
          if (!wards[cityCode]) {
            return []
          }
          const rawData: any = await wards[cityCode]()
          const dataToArray = Object.values(rawData)
          const items = dataToArray.filter((i: any) =>
            (i.name_with_type || '').replaceAll(' ', '').toLowerCase().includes(s.replaceAll(' ', '').toLowerCase())
          ) as []
          return items
        },
        findWard: async (s: string = '', districtCode: string | undefined) => {
          if (!districtCode || districtCode === undefined || districtCode === '') {
            return []
          }
          if (!districts[districtCode]) {
            return []
          }
          const rawData: any = await districts[districtCode]()
          const dataToArray = Object.values(rawData)
          const items = dataToArray.filter((i: any) =>
            (i.name_with_type || '').replaceAll(' ', '').toLowerCase().includes(s.replaceAll(' ', '').toLowerCase())
          ) as []
          return items
        },
        getLocation: (id: string) => {
          if (!id) {
            return
          }
          const locations = library.locations || []
          const foundItem = locations.find((item: any) => item._id === id)
          return foundItem
        }
      }
    }
  }
})
